import { ArrowRight } from "lucide-react";

const TrustedCta = () => {
  return (
    <section className="px-5 py-10 sm:px-6 lg:px-20 lg:py-20">
      <div
        className="relative w-full overflow-hidden rounded-[20px] bg-[#000714] py-14 sm:py-20 lg:rounded-[32px] lg:py-28"
        style={{
          backgroundImage:
            "url(/assets/homePage/fourStagesSection/grid-gradient.svg)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center -10px",
          backgroundSize: "cover",
        }}
      >
        <div className="absolute left-1/2 top-1/2 h-[130px] w-[300px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0C1C82] blur-[50px] lg:h-[420px] lg:w-[800px] lg:bg-[#121948] lg:blur-[100px]" />

        <article className="relative z-[2] flex flex-col items-center gap-5 px-5 text-center sm:px-6 lg:gap-6">
          <h2 className="text-[26px] font-[400] tracking-[0.5px] leading-6 text-white sm:text-[34px] md:text-[44px] lg:text-5xl 3xl:text-[64px]">
            <div>Trusted by Marketers</div>
            <div className="mt-2">Who Test, Learn, and</div>
            <div className="mt-2">
              <span
                className="font-semibold"
                style={{
                  background:
                    "linear-gradient(to bottom, rgba(129,140,248,0) 0%, rgba(129,140,248,0) 50%, rgba(129,140,248,0.4) 50%, rgba(129,140,248,0.4) 100%)",
                }}
              >
                Scale
              </span>
              .
            </div>
          </h2>
          <p className="mx-auto max-w-[420px] text-[14px] font-normal tracking-[-0.3px] text-[#D2D2D2] sm:text-[16px] lg:max-w-[500px] lg:text-lg 3xl:text-xl">
            Join 1,000+ teams using Imagive to craft smarter, high-performing
            campaigns.
          </p>

          <div className="mx-auto mt-2 flex w-full max-w-[420px] flex-col items-stretch gap-3 sm:flex-row sm:justify-center lg:mt-4 lg:w-auto lg:max-w-none lg:items-center">
            <a
              href="https://app.imagive.ai?redirect=/users/brands"
              target="_blank"
              className="group inline-flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-lg bg-indigo-800 px-6 py-3 text-[14px] font-medium text-white shadow-[inset_0px_1px_0px_0px_rgba(255,255,255,0.08)] lg:flex-initial lg:rounded-xl lg:py-4"
            >
              Start creating ads
              <ArrowRight
                size={16}
                className="transition-all duration-300 group-hover:translate-x-1"
              />
            </a>
            <a
              href="https://cal.com/imagive.ai/30min"
              target="_blank"
              className="inline-flex flex-1 cursor-pointer items-center justify-center rounded-lg bg-[#FBFAF7] px-6 py-3 text-[14px] font-medium text-[#000714] outline outline-1 -outline-offset-1 outline-color-grey-76 hover:bg-[#FBFAF7]/95 lg:flex-initial lg:rounded-xl lg:py-4"
            >
              Book a walkthrough
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};

export default TrustedCta;
